import { Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { useRelativeDateFormat } from "PFCore/hooks/use_relative_date_format";
import { Id } from "PFTypes";

type Notification = {
  id: Id;
  body: string;
  status: string;
  created_at: string;
  title: string;
  category_type: string;
};

type NotificationItemProps = {
  notification: Notification;
};

export const NotificationItem = ({ notification: { title, created_at, body } }: NotificationItemProps) => {
  const relativeDateFormat = useRelativeDateFormat();

  return (
    <Stack gap="spacingMd">
      <Typography variant="bodyBold">{title}</Typography>
      <Typography variant="labelRegular">{body}</Typography>
      <Typography variant="labelRegular">{relativeDateFormat(created_at)}</Typography>
    </Stack>
  );
};
